import { renderDividerBlock } from '../render/blocks/divider';
import { DividerBlockSettings } from '../settings/blocks/divider';
import { defineBlockRegistryEntry } from './defineEntry';
import { dividerBlockDefinition } from '../domain/blocks/divider';

export const dividerBlockRegistryEntry = defineBlockRegistryEntry(
  dividerBlockDefinition,
  renderDividerBlock,
  DividerBlockSettings,
);
